import { useTranslate } from "@similarweb/i18n-provider";

import { StyledEmptyState } from "./styles";

type Props = {
    variant: "search";
};

export const FiltersListEmptyState = ({ variant }: Props) => {
    const { translate } = useTranslate();

    return (
        <StyledEmptyState
            iconName="no-data-lab"
            title={translate(`si.filters-panel.${variant}.no-results.text`)}
            subtitle={translate(`si.filters-panel.${variant}.no-results.hint`)}
        />
    );
};